
import Vue from "vue";
import { Component } from "vue-property-decorator";
import ElementStudioWidthAdjustmentBar from "./ElementStudioWidthAdjustmentBar.vue";

import ElementStudioElements from "@/components/ElementStudio/ElementStudioElements.vue";
import { isBreakdanceDevelopmentEnvironment } from "@/lib/dev/development-environment";
import { pipe } from "fp-ts/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import {
  ElementStudioExpectedDataToLoad,
  ElementStudioExpectedDataToLoadV,
  SaveLocationType
} from "@/types/element-studio";
import { fold } from "fp-ts/Either";
import NotificationLogger from "@/lib/notifications/notifications";
import ElementStudioMacros from "@/components/ElementStudio/ElementStudioMacros.vue";
import defensiveCopy from "@/util/defensive-copy";
import ElementStudioPresets from "@/components/ElementStudio/ElementStudioPresets.vue";

@Component({
  components: {
    ElementStudioPresets,
    ElementStudioMacros,
    ElementStudioElements,
    ElementStudioWidthAdjustmentBar
  }
})
export default class ElementStudio extends Vue {
  async mounted() {
    pipe(
      await makeWordPressAjaxRequest({
        action: "breakdance_load_element_studio",
        decoder: ElementStudioExpectedDataToLoadV
      }),
      fold(
        errors => errors.forEach(e => NotificationLogger.log.message(e.msg)),
        expectedDataToLoad => {
          this.data = expectedDataToLoad;
        }
      )
    );
  }

  data: ElementStudioExpectedDataToLoad = {
    elements: [],
    macros: [],
    presets: [],
    saveLocations: [],
    presetSections: []
  };

  width = 600;

  activeItemType: SaveLocationType | null = null;

  updateData(newData: ElementStudioExpectedDataToLoad) {
    this.data = defensiveCopy(newData);
  }

  updateActiveItemType(newType: SaveLocationType | null) {
    this.activeItemType = newType;
  }

  updateWidth(newWidth: number) {
    this.width = newWidth;
  }

  adjustWidth(adjustAmount: number) {
    this.width += adjustAmount;
  }

  get styles() {
    return {
      width: `${this.width}px`
    };
  }

  get isProdEnv() {
    return !isBreakdanceDevelopmentEnvironment();
  }
}
